import { render, staticRenderFns } from "./single_course.vue?vue&type=template&id=34cab397&scoped=true&"
import script from "./single_course.vue?vue&type=script&lang=ts&"
export * from "./single_course.vue?vue&type=script&lang=ts&"
import style0 from "./single_course.vue?vue&type=style&index=0&id=34cab397&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cab397",
  null
  
)

export default component.exports